<div class="">
  <p-toast />
  <div>
    <p-dialog
      header="Subir acta"
      [(visible)]="minuteDialogVisible"
      [modal]="true"
      [closable]="false"
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    >
      <app-minute
        (loadingChange)="handleLoadingChange($event)"
        (closePopup)="cancel($event)"
        [claimId]="claimId"
        [audienceId]="audienceId"
        (showMessage)="handleShowMessage($event)"
        (refresh)="refreshGetAll()"
      ></app-minute>
    </p-dialog>
  </div>
  <p-confirmDialog #cd>
    <ng-template pTemplate="headless" let-message>
      <div
        class="flex flex-column align-items-center justify-content-center p-5 surface-overlay border-round"
      >
        <span class="col-12 font-semibold text-xl">
          {{ message.header }}
        </span>
        <div
          class="col-12 flex align-items-center justify-content-center gap-3"
        >
          <i class="pi pi-exclamation-circle text-lg"></i>
          <p class="">{{ message.message }}</p>
        </div>
        <div class="col-12 flex gap-3 justify-content-center">
          <button
            pButton
            label="Cancelar"
            (click)="cd.reject()"
            class="btn-cancelar"
            style="
              border: 1px solid #263245;
              background-color: white;
              color: #263245;
              font-size: 0.8rem;
            "
          ></button>
          <button
            pButton
            label="Eliminar audiencia"
            (click)="cd.accept()"
            class="btn-siguiente"
            style="
              background-color: #e9ecf2;
              color: #263245;
              border-color: #000000;
              font-size: 0.8rem;
            "
          ></button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
</div>

<div class="grid w-full relative p-3">
  <p-table
    [tableStyle]="{ 'min-width': '100%' }"
    class="col-12"
    [rowHover]="true"
    *ngIf="skeleton"
    [value]="skeletons"
  >
    <ng-template pTemplate="header">
      <tr class="font-semibold text-xs">
        <th>Fecha</th>
        <th class="text-center">Hora</th>
        <th *ngIf="!homeView" class="text-center">Título de audiencia</th>
        <th *ngIf="!homeView" class="text-center">Conciliador</th>
        <th class="text-center">N° de reclamo</th>
        <th *ngIf="!homeView" class="text-center">N° de expediente</th>
        <th class="text-center">Reclamante</th>
        <th class="text-center">Reclamado</th>
        <th class="text-center">Tipo de reclamo</th>
        <th></th>
        <th>Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-skeleton>
      <tr>
        <td class="text-center"><p-skeleton></p-skeleton></td>
        <td class="text-center"><p-skeleton></p-skeleton></td>
        <td class="text-center"><p-skeleton></p-skeleton></td>
        <td class="text-center"><p-skeleton></p-skeleton></td>
        <td class="text-center"><p-skeleton></p-skeleton></td>
        <td class="text-center"><p-skeleton></p-skeleton></td>
        <td class="text-center"><p-skeleton></p-skeleton></td>
        <td class="text-center"><p-skeleton></p-skeleton></td>
        <td class="text-center" *ngIf="!homeView"><p-skeleton></p-skeleton></td>
        <td class="text-center" *ngIf="!homeView"><p-skeleton></p-skeleton></td>
        <td class="text-center" *ngIf="!homeView"><p-skeleton></p-skeleton></td>
      </tr>
    </ng-template>
  </p-table>

  <div class="col-12" *ngIf="!homeView && allAudiences?.length">
    <app-audience-filter
      class="modal-content"
      (filters)="onFiltersApplied($event)"
      (cancel)="onFilterCancel()"
    ></app-audience-filter>
  </div>

  <p-table
    *ngIf="!skeleton && haveResults"
    #dtAudience
    (onLazyLoad)="loadRecords($event)"
    [tableStyle]="{ 'min-width': '100%' }"
    [value]="allAudiences"
    class="col-12"
  >
    <ng-template pTemplate="header">
      <tr class="font-semibold text-xs">
        <th>Fecha</th>
        <th class="text-center">Hora</th>
        <th *ngIf="!homeView" class="text-center">Título de audiencia</th>
        <th *ngIf="!homeView" class="text-center">Conciliador</th>
        <th class="text-center">N° de reclamo</th>
        <th class="text-center">N° de expediente</th>
        <th class="text-center">Reclamante</th>
        <th class="text-center">Reclamado</th>
        <th class="text-center">Tipo de reclamo</th>
        <th></th>
        <th>Acciones</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-audience>
      <tr class="table-row">
        <td>
          {{ audience.date | date : "dd/MM/yyyy" }}
        </td>
        <td class="text-center">{{ audience.time }}</td>
        <td class="text-center" *ngIf="!homeView">
          <span [pTooltip]="audience.audienceTitle" tooltipPosition="top">
            {{ audience.audienceTitle | truncate }}
          </span>
        </td>
        <td class="text-center" *ngIf="!homeView">
          {{ audience.conciliator }}
        </td>
        <td class="text-center">{{ audience.numberOfClaim }}</td>
        <td class="text-center">
          {{ audience.proceedings }}
        </td>
        <td class="text-center">
          <span
            [pTooltip]="
              (audience.claimetName ?? '') +
              ' ' +
              (audience.claimetLastname ?? '')
            "
            tooltipPosition="top"
          >
            {{
              (audience.claimetName ?? "") +
                " " +
                (audience.claimetLastname ?? "") | truncate
            }}
          </span>
        </td>
        <td class="text-center">
          <span
            [pTooltip]="audience.claimedNameLastNameOrBusinessName"
            tooltipPosition="top"
          >
            {{ audience.claimedNameLastNameOrBusinessName | truncate }}
          </span>
        </td>
        <td style="width: 10%" class="text-center">
          <span
            class="type-claim"
            [ngClass]="
              audience.claim_type == 'Pluri-Individual'
                ? 'type-claim-multi'
                : audience.claim_type == 'Colectivo'
                ? 'type-claim-colle'
                : 'type-claim-indi'
            "
            >{{ audience.claim_type ? audience.claim_type : "-" }}</span
          >
        </td>
        <td class="text-right p-0">
          <img
            *ngIf="audience.acta_id"
            src="../../../../../../assets/img/main/icon-pdf.svg"
            class="icon-pdf"
          />
        </td>
        <td class="col-12 sm:col-6 md:col-1 text-center p-0">
          <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
          <button
            type="button"
            pButton
            icon="pi pi-ellipsis-v"
            (click)="
              selectAmountComisionItems();
              menu.toggle($event);
              selectAudience(audience.id, audience.claimId)
            "
            class="p-button-rounded p-button-text"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="!haveResults || !allAudiences?.length" class="col-12">
    <div
      class="flex flex-column align-items-center fadein animation-duration-500"
    >
      <img
        src="../../../../../../assets/img/main/file-searching.svg"
        alt="imagen de archivo"
        style="width: 200px; height: 15R0px"
      />
      <p style="color: #4b5563">No hay audiencias para visualizar</p>
    </div>
  </div>

  <p-paginator
    class="col-12"
    *ngIf="!homeView && pagination.totalQuantity"
    (onPageChange)="changePage($event)"
    [first]="(pagination.actualPage - 1) * pagination.itemsPerPage"
    [rows]="pagination.itemsPerPage"
    [totalRecords]="pagination.totalQuantity"
    [rowsPerPageOptions]="[5, 10, 25, 50]"
  >
  </p-paginator>
</div>
